import Vue from 'vue'
import { prefix } from "../../config/env";
import {setStore, getStore, clearStore} from '../../config/mUtils'
const USER_ANSWER_SIGNIN = 'USER_ANSWER_SIGNIN'// 写入题目
const USER_ANSWER_SIGNOUT = 'USER_ANSWER_SIGNOUT' // 删除写入题目
export default {
  state: JSON.parse(getStore(`${prefix}user_answer`)) || null,
  mutations: {
    [USER_ANSWER_SIGNIN] (state, data) {
      setStore(`${prefix}user_answer`, JSON.stringify(data))
      Object.assign(state, data)
    },
    [USER_ANSWER_SIGNOUT] (state) {
      clearStore()
      Object.keys(state).forEach(k => Vue.delete(state, k))
    }
  },
  actions: {
    [USER_ANSWER_SIGNIN] ({commit}, data) {
      commit(USER_ANSWER_SIGNIN, data)
    },
    [USER_ANSWER_SIGNOUT] ({commit}) {
      commit(USER_ANSWER_SIGNOUT)
    }
  }
}
